import React, { useState, useEffect } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import styles from './NewFilterFollowUp.module.scss';
import { getAdminIds } from '../../services/candidateServices';
import { useSelector } from 'react-redux';
import { decryptedAdminID } from '../../utility';
import DateFilter from '../../components/Common/FilterComponent/DateFilter';
import { AiOutlineClose } from 'react-icons/ai';

const ALL_OPTION = { id: 'ALL', name: 'All' };

const TITLE_OPTIONS = [
  { value: '', label: 'All Titles' },
  { value: 'Document Remainder', label: 'Document Remainder' },
  { value: 'Tentative date', label: 'Tentative date' },
  { value: 'Call Remainder', label: 'Call Remainder' },
  { value: 'Interview Follow Up', label: 'Interview Follow Up' },
  { value: 'Joining Follow Up', label: 'Joining Follow Up' },
];

const NewFilterFollowUp = ({ 
  columnKey, 
  isGlobal, 
  currentFilter = null,
  onApply,
  onClear,
  onClose 
}) => {
  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails?.roleID == 1;
  const adminID = Number(decryptedAdminID());
  
  const [adminList, setAdminList] = useState([]);
  const [loadingAdmins, setLoadingAdmins] = useState(false);
  
  // Filter states
  const [dateRange, setDateRange] = useState({
    date_from: currentFilter?.dateRange?.start || '',
    date_to: currentFilter?.dateRange?.end || ''
  });
  const [priority, setPriority] = useState(currentFilter?.priority || '');
  const [orderByPriority, setOrderByPriority] = useState(currentFilter?.orderByPriority || false);
  const [admin_ids, setAdminIds] = useState([]);
  const [title, setTitle] = useState(currentFilter?.title || '');
  const [dateFilterResetTrigger, setDateFilterResetTrigger] = useState(0);
  
const isTeamLeader = localStorage.getItem("teamLeader") == "true";
  const priorityOptions = [
    { value: '', label: 'All Priorities' },
    { value: 'CRITICAL', label: 'Critical' },
    { value: 'HIGH', label: 'High' },
    { value: 'MEDIUM', label: 'Medium' },
    { value: 'LOW', label: 'Low' }
  ];

  // Fetch admin list
  // useEffect(() => {
  //   const fetchAdmins = async () => {
  //     setLoadingAdmins(true);
  //     try {
  //       const result = await getAdminIds({
  //         id: adminID,
  //         onlyMe: false,
  //       });

  //       let formattedAdmins = [];
        
  //       if (result?.data && Array.isArray(result.data)) {
  //         formattedAdmins = result.data.map((item) => ({
  //           id: item.admin_id,
  //           name: item.admin_id === adminID ? "Self" : (item.user_name || `Admin ${item.admin_id}`),
  //         }));
  //       }

  //       setAdminList(formattedAdmins);

  //       if (currentFilter?.admin_ids && currentFilter.admin_ids.length > 0) {
  //         setAdminIds(currentFilter.admin_ids);
  //       } else {
  //         if (isSuperAdmin) {
  //           setAdminIds([]);
  //         } else {
  //           setAdminIds([adminID]);
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Error fetching admin list:', error);
  //       if (currentFilter?.admin_ids && currentFilter.admin_ids.length > 0) {
  //         setAdminIds(currentFilter.admin_ids);
  //       } else {
  //         setAdminIds(isSuperAdmin ? [] : [adminID]);
  //       }
  //     } finally {
  //       setLoadingAdmins(false);
  //     }
  //   };

  //   fetchAdmins();
  // }, [currentFilter]);

  // In the fetchAdmins useEffect, update the else condition:
// useEffect(() => {
//   const fetchAdmins = async () => {
//     setLoadingAdmins(true);
//     try {
//       const result = await getAdminIds({
//         id: adminID,
//         onlyMe: false,
//       });

//       let formattedAdmins = [];
      
//       if (result?.data && Array.isArray(result.data)) {
//         formattedAdmins = result.data.map((item) => ({
//           id: item.admin_id,
//           name: item.admin_id === adminID ? "Self" : (item.user_name || `Admin ${item.admin_id}`),
//         }));
//       }

//       setAdminList(formattedAdmins);

//       if (currentFilter?.admin_ids && currentFilter.admin_ids.length > 0) {
//         setAdminIds(currentFilter.admin_ids);
//       } else {
//         // For Super Admin OR Team Leader - empty array = ALL admins
//       // To this:
// if (isSuperAdmin) {
//   setAdminIds([]); // Empty = ALL admins shown in filter
// } else {
//   setAdminIds([adminID]); // Self selected by default (Team Leader + Regular Admin)
// }
//       }
//     } catch (error) {
//       console.error('Error fetching admin list:', error);
//       if (currentFilter?.admin_ids && currentFilter.admin_ids.length > 0) {
//         setAdminIds(currentFilter.admin_ids);
//       } else {
//         // For Super Admin OR Team Leader - empty array = ALL admins
//         setAdminIds((isSuperAdmin || isTeamLeader) ? [] : [adminID]);
//       }
//     } finally {
//       setLoadingAdmins(false);
//     }
//   };

//   fetchAdmins();
// }, [currentFilter]);

// ✅ Get admin list from localStorage on mount
// Get admin list from localStorage on mount
useEffect(() => {
  const stored = JSON.parse(localStorage.getItem("AdminList") || "[]");
  console.log("AdminList from localStorage:", stored);
  
  // Format with "Self" for current admin
  const formattedWithSelf = stored.map((item) => ({
    id: item.id,
    name: item.id === adminID ? "Self" : item.name,
  }));
  
  setAdminList(formattedWithSelf);
  setLoadingAdmins(false);
}, [adminID]);

// ✅ Listen for storage events (if admin list changes in another tab)
useEffect(() => {
  const syncAdminList = () => {
    const stored = JSON.parse(localStorage.getItem("AdminList") || "[]");
    setAdminList(stored);
  };

  window.addEventListener("storage", syncAdminList);

  return () => {
    window.removeEventListener("storage", syncAdminList);
  };
}, []);

  // Sync with currentFilter when it changes
  useEffect(() => {
    if (currentFilter?.admin_ids && currentFilter.admin_ids.length > 0 && adminList.length > 0) {
      if (currentFilter.admin_ids.length === adminList.length) {
        setAdminIds(adminList.map(a => a.id));
      } else {
        setAdminIds(currentFilter.admin_ids);
      }
    } else if (currentFilter && (!currentFilter.admin_ids || currentFilter.admin_ids.length === 0)) {
      setAdminIds([]);
    }
    
    if (currentFilter?.dateRange) {
      setDateRange({
        date_from: currentFilter.dateRange.start || '',
        date_to: currentFilter.dateRange.end || ''
      });
    }
  }, [currentFilter, adminList]);

  const handleAdminChange = (event, value) => {
    if (!value) {
      setAdminIds([]);
      return;
    }

    if (value.id === 'ALL') {
      setAdminIds([]);
      return;
    }

    setAdminIds([value.id]);
  };

  const selectedAdminValue = (() => {
    if (!admin_ids?.length || admin_ids.length === 0) {
      return ALL_OPTION;
    }
    
    if (!adminList.length) return ALL_OPTION;

    if (admin_ids.length === adminList.length && adminList.length > 0) {
      return ALL_OPTION;
    }

    if (admin_ids.length === 1) {
      const selected = adminList.find((a) => a.id === admin_ids[0]);
      return selected || ALL_OPTION;
    }
    
    return ALL_OPTION;
  })();

  const handleDateChange = (dateData) => {
    setDateRange({
      date_from: dateData.date_from || '',
      date_to: dateData.date_to || ''
    });
  };

// const handleApply = () => {
//   const filterData = {};
  
//   // Handle date range - only add if both dates exist
//   if (dateRange.date_from && dateRange.date_to) {
//     filterData.dateRange = {
//       start: dateRange.date_from,
//       end: dateRange.date_to
//     };
//   } else if (dateRange.date_from) {
//     filterData.dateRange = {
//       start: dateRange.date_from,
//       end: dateRange.date_from
//     };
//   } else if (dateRange.date_to) {
//     filterData.dateRange = {
//       start: dateRange.date_to,
//       end: dateRange.date_to
//     };
//   } else {
//     // ✅ CRITICAL: Send empty date range when cleared
//     filterData.dateRange = { start: '', end: '' };
//   }
  
//   // ✅ Handle priority - send null when cleared (not empty string)
//   if (priority && priority !== '') {
//     filterData.priority = priority;
//   } else {
//     filterData.priority = null; // Explicitly set to null when cleared
//   }
  
//   // ✅ Handle orderByPriority - always send boolean
//   filterData.orderByPriority = orderByPriority === true;
  
//   // ✅ Handle title - send null when cleared
//   if (title && title !== '') {
//     filterData.title = title;
//   } else {
//     filterData.title = null; // Explicitly set to null when cleared
//   }
  
//   // ✅ Handle admin_ids
//   if (admin_ids && admin_ids.length > 0) {
//     filterData.admin_ids = admin_ids;
//     console.log('Applying filter with specific admin:', admin_ids);
//   } else {
//     // For Super Admin, empty array means ALL admins
//     // For regular admin, this will be handled by parent
//     filterData.admin_ids = [];
//     console.log('Applying filter with ALL admins (empty admin_ids)');
//   }
  
//   console.log('📤 Applying filter data:', filterData);
  
//   if (onApply) {
//     onApply(filterData);
//   }
// };
//  const handleClear = () => {
//   // Reset all form fields
//   setDateRange({ date_from: '', date_to: '' });
//   setDateFilterResetTrigger(prev => prev + 1);
//   setPriority('');
//   setOrderByPriority(false);
//   setTitle('');
  
//   // Reset admin IDs based on user role
//   let resetAdminIds = [];
//   if (isSuperAdmin) {
//     resetAdminIds = []; // Empty array means ALL admins for Super Admin
//   } else {
//     resetAdminIds = [adminID]; // Regular admin sees only themselves
//   }
  
//   setAdminIds(resetAdminIds);
  
//   console.log('🧹 Clear All: Resetting all filters');
  
//   // Create cleared filter data object
//   const clearedFilterData = {
//     dateRange: { start: '', end: '' },
//     priority: null,
//     orderByPriority: false,
//     title: null,
//     admin_ids: resetAdminIds
//   };
  
//   // Call onClear with the cleared data
//   if (onClear) {
//     onClear(clearedFilterData);
//   }
  
//   // Close the modal
//   if (onClose) {
//     onClose();
//   }
// };

// In NewFilterFollowUp.js, update handleApply function
const handleApply = () => {
  const filterData = {};
  
  // Handle date range
  if (dateRange.date_from && dateRange.date_to) {
    filterData.dateRange = {
      start: dateRange.date_from,
      end: dateRange.date_to
    };
  } else if (dateRange.date_from) {
    filterData.dateRange = {
      start: dateRange.date_from,
      end: dateRange.date_from
    };
  } else if (dateRange.date_to) {
    filterData.dateRange = {
      start: dateRange.date_to,
      end: dateRange.date_to
    };
  } else {
    filterData.dateRange = { start: '', end: '' };
  }
  
  // Handle priority
  if (priority && priority !== '') {
    filterData.priority = priority;
  } else {
    filterData.priority = null;
  }
  
  // Handle orderByPriority
  filterData.orderByPriority = orderByPriority === true;
  
  // Handle title
  if (title && title !== '') {
    filterData.title = title;
  } else {
    filterData.title = null;
  }
  
  // ✅ Handle admin_ids - check if it's different from default
  let isAdminFilterDifferent = false;
  
  // Determine default admin IDs based on role
  const isSuperAdmin = adminDetails?.roleID == 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true";
  
  let defaultAdminIds = [];
  if (isSuperAdmin) {
    defaultAdminIds = []; // ALL admins is default
  } else {
    defaultAdminIds = [adminID]; // Self is default
  }
  
  // Get current selection
  let currentAdminIds = [];
  if (admin_ids && admin_ids.length > 0) {
    currentAdminIds = admin_ids;
  } else {
    currentAdminIds = []; // Empty means ALL
  }
  
  // Compare current with default
  const sortedCurrent = [...currentAdminIds].sort();
  const sortedDefault = [...defaultAdminIds].sort();
  
  if (sortedCurrent.length !== sortedDefault.length) {
    isAdminFilterDifferent = true;
  } else {
    for (let i = 0; i < sortedCurrent.length; i++) {
      if (sortedCurrent[i] !== sortedDefault[i]) {
        isAdminFilterDifferent = true;
        break;
      }
    }
  }
  
  // Pass admin_ids
  filterData.admin_ids = currentAdminIds;
  
  // ✅ Only set flag if different from default
  if (isAdminFilterDifferent) {
    filterData._adminFilterApplied = true;
  }
  
  console.log('📤 Applying filter data:', filterData);
  
  if (onApply) {
    onApply(filterData);
  }
};

const handleClear = () => {
  // Reset all form fields
  setDateRange({ date_from: '', date_to: '' });
  setDateFilterResetTrigger(prev => prev + 1);
  setPriority('');
  setOrderByPriority(false);
  setTitle('');
  
  // Reset admin IDs based on user role
  let resetAdminIds = [];
  // For Super Admin OR Team Leader - empty array means ALL admins
 if (isSuperAdmin) {
  resetAdminIds = []; // Clears to ALL admins
} else {
  resetAdminIds = [adminID]; // Clears back to self (Team Leader + Regular Admin)
}
  
  setAdminIds(resetAdminIds);
  
  console.log('🧹 Clear All: Resetting all filters', { isSuperAdmin, isTeamLeader, resetAdminIds });
  
  // Create cleared filter data object
  const clearedFilterData = {
    dateRange: { start: '', end: '' },
    priority: null,
    orderByPriority: false,
    title: null,
    admin_ids: resetAdminIds
  };
  
  // Call onClear with the cleared data
  if (onClear) {
    onClear(clearedFilterData);
  }
  
  // Close the modal
  if (onClose) {
    onClose();
  }
};

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const getTitle = () => {
    if (isGlobal) return 'Filter';
    return `Filter - ${columnKey.charAt(0).toUpperCase() + columnKey.slice(1)}`;
  };

  return (
    <div className={styles.filterModalContent}>
      <div className={styles.filterModalHeader}>
        <h3>{getTitle()}</h3>
        <button className={styles.closeButton} onClick={handleClose}><AiOutlineClose/> </button>
      </div>
      
      <div className={styles.filterBody}>
        {/* Row 1: Date (Left) & Title (Right) */}
        <div className={styles.filterRow}>
          <div className={styles.filterColumn}>
            <label>Date</label>
            <DateFilter 
              onChange={handleDateChange}
              resetTrigger={dateFilterResetTrigger}
              value={{ 
                date_from: dateRange.date_from, 
                date_to: dateRange.date_to 
              }}
                hideOptions={columnKey === 'todo' ? ['yesterday'] : []}
            />
          </div>
          
          <div className={styles.filterColumn}>
            <label>Title</label>
            <select 
              value={title} 
              onChange={(e) => setTitle(e.target.value)}
              className={styles.selectInput}
            >
              {TITLE_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Row 2: Priority (Left) & Order by Priority (Right) */}
        <div className={styles.filterRow}>
          <div className={styles.filterColumn}>
            <label>Priority</label>
            <select 
              value={priority} 
              onChange={(e) => setPriority(e.target.value)}
              className={styles.selectInput}
            >
              {priorityOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
          
          {/* Updated Order by Priority with Card Style */}
          <div className={styles.filterColumn}>
            <div className={styles.orderByContainer}>
              <div className={styles.orderByHeader}>
                {/* <span className={styles.orderByIcon}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M3 6h18M6 12h12M10 18h4" />
                    <path d="M12 2L12 22" strokeDasharray="2 2" />
                  </svg>
                </span> */}
                <span className={styles.orderByLabel}>Enable priority order</span>
              </div>
              <label className={styles.orderByCheckbox}>
                <input
                  type="checkbox"
                  checked={orderByPriority}
                  onChange={(e) => setOrderByPriority(e.target.checked)}
                />
                <div className={styles.checkboxCard}>
                  <div className={styles.checkboxCardContent}>
                    {/* <span className={styles.checkboxCardTitle}>Enable priority order</span> */}
                    <span className={styles.checkboxCardDesc}>(Critical → Low)</span>
                  </div>
                  <div className={`${styles.checkboxCardIndicator} ${orderByPriority ? styles.active : ''}`}>
                    {orderByPriority ? 'ON' : 'OFF'}
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>

        {/* Row 3: Admin Name (Full Width if Super Admin) */}
        {/* {isSuperAdmin && ( */}
        {(isSuperAdmin || isTeamLeader) && (
          <div className={styles.filterRow}>
            <div className={styles.filterColumnFull}>
              {/* <label>Admin Name</label> */}
              <Autocomplete
                options={[ALL_OPTION, ...adminList]}
                getOptionLabel={(option) => {
                  if (!option) return '';
                  if (option.name) return option.name;
                  if (option.user_name) return option.user_name;
                  return `Admin ${option.id}`;
                }}
                value={selectedAdminValue}
                onChange={handleAdminChange}
                isOptionEqualToValue={(opt, val) => {
                  if (!opt || !val) return false;
                  return opt.id === val.id;
                }}
                loading={loadingAdmins}
                disabled={loadingAdmins}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    label="Admin Name" 
                    variant="outlined"
                    size="small"
                    placeholder={loadingAdmins ? "Loading admins..." : "Search admin..."}
                  />
                )}
                className={styles.adminAutocomplete}
              />
            </div>
          </div>
        )}
      </div>

      <div className={styles.filterModalFooter}>
        <button className={styles.clearButton} onClick={handleClear}>
          Clear All
        </button>
        <button className={styles.applyButton} onClick={handleApply}>
          Apply Filter
        </button>
      </div>
    </div>
  );
};

export default NewFilterFollowUp;